import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { CHANNEL_EVENT_TYPES, type ChannelEventRow } from "@/lib/chat-room/system-events";

const LIMIT = 100;

/**
 * Hendelsene som vises som systemmeldinger i en prosjektkanal (VIB-3026):
 * fase endret, oppgave fullført/godkjent og timer registrert. De siste 100,
 * nyeste først fra databasen.
 *
 * Nøkkelen deler prefikset `["project-events", projectId]` med prosjektloggen,
 * så de samme mutasjonene i CACHE_REGISTRY invaliderer kanalen.
 */
export function useProjectChannelEvents(projectId: string | undefined) {
  return useQuery({
    queryKey: ["project-events", projectId, "chat-channel"],
    enabled: !!projectId,
    queryFn: async (): Promise<ChannelEventRow[]> => {
      const { data, error } = await supabase
        .from("project_events")
        .select("id, project_id, user_id, event_type, payload, created_at, user:users(full_name)")
        .eq("project_id", projectId!)
        .in("event_type", [...CHANNEL_EVENT_TYPES])
        .order("created_at", { ascending: false })
        .limit(LIMIT);
      if (error) throw error;
      return (data ?? []) as unknown as ChannelEventRow[];
    },
    staleTime: 30 * 1000,
  });
}
